var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sky-city-background"},[(_vm.comparison)?_c('Buckler',{staticClass:"comparison-buckler",attrs:{"text-top":_vm.textTop,"text-bottom":_vm.comparison.text,"center-image":_vm.comparison.image}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }